// removed by extract-text-webpack-plugin
module.exports = {"iconsGroup":"_2hwi9BREApxXYKZqSfS6Lb","iconsText":"_25xI00fw8VOM9W49ucq9wH","icons":"_1-CeKoY33x2STwzCZivAk7","priceLine":"_3naDIbJTy1mmhVHIydb3rN","addressLine":"btxr9EoCgDMa8wWBTqIM6","pricePerSqM":"_3mkZIA8b_4cCBoZ1Qe0Fjc","streetName":"_2EeKCsSv1QXOwwotJnh2ZP","neighborhood":"_1MvDT1KyHNQVbocGz4CJgQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertySummary/PropertySummary.scss
// module id = 1705
// module chunks = 0